import React from 'react'
import './style.sass'

export function Error500(){

    return(
        <>
            <div className="errorService500">
                <div className="iconSession"></div>
                <h1 className="titleMessage">¡Es cuestión de tiempo!</h1>
                <p className="textMessage">Estamos trabajando para mejorar tu experiencia, <strong>por favor inténtalo más tarde.</strong></p>

            </div>
        </>
    )
}